var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DiscountManagement',{attrs:{"btnText":"新增秒杀活动","activity":2,"childRoute":"addNewActivity"}})}
var staticRenderFns = []

export { render, staticRenderFns }